import { render, staticRenderFns } from "./MainNavAvatar.vue?vue&type=template&id=06bb8279&scoped=true&"
import script from "./MainNavAvatar.vue?vue&type=script&lang=js&"
export * from "./MainNavAvatar.vue?vue&type=script&lang=js&"
import style0 from "./MainNavAvatar.vue?vue&type=style&index=0&id=06bb8279&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb8279",
  null
  
)

export default component.exports